import { makeAutoObservable, runInAction } from "mobx";
import { McpServerInstallStatus } from "@shared/constants/mcp"
import { request } from '@/common'
import Other from "@/common/helper/other"
import slsLogger from "@public/log/sls"
import client from '@/store/client'
import navbarStore from "@/store/navbar";
import chatStoreManager from "@/store/chat/manager";

class AgentInstall {
  show = false
  list = []
  installed = false 
  confirmModal = null
  agentInfo = null
  constructor() {
    window['AgentInstall'] = this
    makeAutoObservable(this);
  }
  showInstaller = () => {
    runInAction(() => {
      this.show = true
    })
  }
  setInstallerList = (list) => {
    runInAction(() => {
      this.list = list
    })
  }
  setInstallerStart = () => {
    runInAction(() => {
      this.installed = false
    })
  }
  setInstallerEnd = () => {
    runInAction(() => {
      this.installed = true
    })
  }
  hideInstaller = () => {
    runInAction(() => {
      this.show = false
      this.list = []
    })
  }
  shouldInstall = async(agentId) => {
    this.confirmModal?.destroy?.()
    const res = await request.get('/ai_agent/detail', {
      method: 'get',
      params: {
        id: agentId,
      }
    })
    // TODO 接口错误处理
    if (res.code != 0) {
      Other.toast(res.message)
      return Promise.resolve(null)
    }
    // 取出需要安装的mcp服务
    this.agentInfo = res.data
    const list = (res.data.server_list || []).map(server => {
      if (server.is_local == 1) {
        const status = client.supportMcpAgent
          ? McpServerInstallStatus.installed
          : McpServerInstallStatus.unInstalled
        return {...server, status}
      }
      return {...server, status: McpServerInstallStatus.installed} // 云mcp无需安装
    })
    // 没有服务列表直接跳过
    if (!list.length) {
      console.info('>>> 无服务列表，跳过安装流程')
      return Promise.resolve(null)
    }

    // 先查询安装状态
    const server_names = list
      .filter(server => server.is_local == 1)
      .map(server => server.server_name)
    // console.info('>>> 查询本地 MCP 服务状态', server_names)
    // 如果没有本地mcp服务（1），直接跳过安装流程
    if (!server_names.length) {
      console.info('>>> 无本地 MCP 服务，跳过安装流程')
      this.setInstallerEnd()
      this.hideInstaller()
      return Promise.resolve(null)
    }

    // 开始执行安装
    console.info('>>> 正在展现列表', list)
    this.setInstallerList(list)
    this.showInstaller()
    this.setInstallerStart()

    if (server_names.length && !client.supportMcpAgent) {
      const tips = (client.isLLQ || client.isSeLLQ) ? '请升级至最新版,体验完整功能' : '前往下载页面安装最新客户端,体验完整功能'
      // this.setInstallerEnd()
      // this.hideInstaller()
      // 0517移除尚未创建的对话
      navbarStore.deleteHistoryItem(chatStoreManager.currentId)
      const confirmModal = Other.confirm({
        title: '温馨提示',  
        content: tips,
        onOk: () => {
          client.openPage('/download');
        },
      });
      this.confirmModal = confirmModal
      return Promise.resolve('notSupportMcpAgent')
    }

    // const params = HelperCore.getParams()
    // if(params.share == "1") {
    //   Other.toast("请保证下载最新PC端")
    // }

    console.info('>>> 现在查询mcp服务安装状态：', server_names.join(','))
    const beginTimeStatus = +new Date
    // 查询本地服务安装状态流程
    let needInstallServerNames = []
    try {
      const statusRes = await client.proxyRequestAsyncWithTimeout("McpQuery", {
        api : `/api/server/status`,
        method : 0,
        timeout : 1000, 
        param : {
          server_names,
        }
      }, "", "360Mcp")
      const serverList = JSON.parse(statusRes.data).data
      console.info('>>> 查询mcp服务安装状态：', serverList)
      if (!serverList) {
        throw new Error('>>> 查询mcp服务安装状态失败：serverList不存在')        
      }
      needInstallServerNames = serverList.filter(item => !item.installed)
    } catch (e) {
      // 如果超时，认为所有服务都需要安装
      console.info(e, ' >>> 认为所有服务都需要安装')
      needInstallServerNames = [].concat(server_names)
      slsLogger.log({
        key : "client",
        action : "status_timeout",
        arrt : "McpQuery",
        count : +new Date - beginTimeStatus,
        ext : e.stack || e.toString(),
        ext2 : JSON.stringify(server_names),
        ext3 : JSON.stringify(list),
      });
    }

    if (!needInstallServerNames.length) {
      const newList = list.map(item => {
        item.status = McpServerInstallStatus.installed
        return item
      })
      console.info('>>> 无需安装，但是仍旧更新列表', newList)
      this.setInstallerList(newList)
    } else if (needInstallServerNames.length) {
      console.info('>>> 开始执行安装流程', server_names.join(','))
      // 开始执行安装
      // this.setInstallerList(list)
      // this.showInstaller()
      // this.setInstallerStart()
      // 接上一步：如果并非都是已安装状态，则按server_names逐一调用安装流程
      const beginTime = +new Date
      const promises = server_names.map(server_name => {
        return new Promise(resolve => {
          return client.proxyRequestAsyncWithTimeout("McpQuery", {
            api : "/api/server/install/batch",
            method : 0,
            timeout : 60000, 
            param : {
              server_name,
            }
          }, "", "360Mcp", 2)
          .then(res => {
            console.info('>>> 正在安装指定 MCP', server_name, res)
            try {
              const { code, data } = JSON.parse(res.data)
              if (code != 0) {
                const newList = this.list.map(item => {
                  if (item.server_name === server_name) {
                    item.status = McpServerInstallStatus.failed
                  }
                  return item
                })
                this.setInstallerList(newList)
                return resolve()
              }

              const newList = this.list.map(item => {
                if (item.serverName === server_name) {
                  data.forEach(d => {
                    if (d.server_name === server_name) {
                      item.status = d.installed
                        ? McpServerInstallStatus.installed
                        : McpServerInstallStatus.failed
                    }
                  })
                }
                return item
              })
              console.info('该mcp安装完毕', server_name, newList)
              this.setInstallerList(newList)
              return resolve()
            } catch (e) {
              console.error(`安装 MCP 服务列表 Error:`, e)
              const newList = this.list.map(item => {
                if (item.server_name === server_name) {
                  item.status = McpServerInstallStatus.failed
                }
                return item
              })
              this.setInstallerList(newList)
              return resolve()
            }
          })
        })
      })
      await Promise.all(promises)

      slsLogger.log({
        key : "client",
        action : "install_over",
        count : +new Date - beginTime,
        ext2 : server_names.join(","),
        ext3 : JSON.stringify(this.list),
      });
      console.info(`>>> 安装 MCP 服务列表完成`)
    }

    // const newList = this.list.map(item => {
    //   if (item.is_local != 1 || item.status == McpServerInstallStatus.installed) {
    //     item.installed = true
    //   }
    //   return item
    // })
    // this.setInstallerList(newList)

    //  返回本地 mcpInfo，因为只有本地mcp才需要安装，安装完毕后需要提交给服务端
    let outMcpInfo = null
    const locals = this.list.filter(item => item.is_local == 1).map(item => item.server_name);
    if (locals.length) {
      console.info(`>>> 现在获取本地 mcpInfo`, locals.join(','))
      const params = {
        api : "/api/tools/batch", 
        method : 0,
        timeout : 3000,
        param : {
          server_names : locals,
        },
      }
      const res = await client.proxyRequestAsyncWithTimeout("McpQuery", params, "", "360Mcp");
      const {
        data,
      } = res;
      const result = JSON.parse(data);
      const mcp = result.data;
      if(mcp && Array.isArray(mcp)){
        outMcpInfo = mcp
      }
    }
    
    setTimeout(() => {
      this.setInstallerEnd()
      this.hideInstaller()
    }, 1200)
    console.info('>>> mcp shouldInstall 流程结束', outMcpInfo)
    return Promise.resolve(outMcpInfo)
  }
}

const store = new AgentInstall()
export default store
